import gql from 'graphql-tag';
import { PaymentCodStatus } from 'views/CashOnDelivery/Routes/CashOnDeliveryByShipment/common/model/paymentCodStatus.model';

export interface PaymentCodVars {
  _id: string;
}

export interface CodItem {
  _id: string;
  vendor: {
    _id: string;
    full_name: string;
  };
  total_cod: number;
  cod_in_date: string;
  delivered_date: string;
}

export interface Cod {
  _id: string;
  cod_in_number: string;
  customer: {
    _id: string;
    full_name: string;
  };
  pick_up_date: string;
  delivered_date: string;
  booking_number: string;
  total_cod: number;
  due_date: string;
  cod_item: CodItem[];
  total_vendor: number;
  confirm_status: number;
}

export interface PaymentCodData {
  paymentCod: {
    _id: string;
    cod_out_number: string;
    payment_cod_status: PaymentCodStatus;
    total_cod: number;
    payment_cod_remark: string;
    customer: {
      _id: string;
      full_name: string;
      address: string;
      tax_id: string;
      phone: string[];
      email: string[];
    };
    payment_method: string;
    bank_account: {
      bank_name: string;
      bank_branch: string;
      account_name: string;
      account_number: string;
    };
    cod: Cod[];
    proof_slip: string;
  };
}

export default gql`
  query PaymentCod($_id: ID!) {
    paymentCod(_id: $_id) {
      _id
      cod_out_number
      payment_cod_status
      total_cod
      payment_cod_remark
      customer {
        _id
        full_name
        address
        tax_id
        phone
        email
      }
      payment_method
      bank_account {
        bank_name
        bank_branch
        account_name
        account_number
      }
      cod {
        _id
        cod_in_number
        customer {
          _id
          full_name
        }
        pick_up_date
        delivered_date
        booking_number
        total_cod
        due_date
        cod_item {
          _id
          vendor {
            _id
            full_name
          }
          total_cod
          cod_in_date
          delivered_date
        }
        total_vendor
        confirm_status
      }
      proof_slip
    }
  }
`;
